export const LATINA_BASE_URL = process.env.REACT_APP_DOMAIN_V3
